/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { GridComponents, VirtuosoGrid } from "react-virtuoso";
import { TreeBrowserNode } from "../types/data-types";
import { GetInteractivity, NodeComponent } from "../types/component-types";

interface TreeBrowserGridVirtualScrollingProps<TNode extends TreeBrowserNode, TExtraProps extends any = undefined> {
    nodes: TNode[];
    components: { [key: string]: NodeComponent<TNode, TExtraProps> };
    extraProps: TExtraProps;
    getInteractivity?: GetInteractivity<TNode>;
    listComponent: GridComponents<never>["List"];
    overscan?: number;
}

/** Virtual scrolling for content in a grid */
export function TreeBrowserGridVirtualScrollingComponent<TNode extends TreeBrowserNode, TExtraProps extends any = undefined>({
    nodes,
    components,
    extraProps,
    getInteractivity,
    listComponent,
    overscan,
}: TreeBrowserGridVirtualScrollingProps<TNode, TExtraProps>) {
    return (
        <VirtuosoGrid
            style={{ height: "100%" }}
            data={nodes}
            components={{
                List: listComponent,
            }}
            itemContent={(_, data) => {
                const NodeComponent = components[data.type];
                return <NodeComponent key={data.id} node={data} extraProps={extraProps} getInteractivity={getInteractivity} />;
            }}
            overscan={overscan}
        />
    );
}
